var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_10091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 3.18726H6L7.33333 6.52059L5.66667 7.52059C6.38064 8.96828 7.55231 10.1399 9 10.8539L10 9.18726L13.3333 10.5206V13.1873C13.3333 13.5409 13.1929 13.88 12.9428 14.1301C12.6928 14.3801 12.3536 14.5206 12 14.5206C9.39951 14.3626 6.94677 13.2583 5.10455 11.416C3.26234 9.57382 2.15803 7.12108 2 4.52059C2 4.16697 2.14048 3.82783 2.39052 3.57778C2.64057 3.32773 2.97971 3.18726 3.33333 3.18726",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_10091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.520508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.36c086ff759205cc6778c03c6263aee0.svg";
export { ForwardRef as ReactComponent };